import React, { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { motion } from 'framer-motion';
export function ThemeToggle() {
  const [isDarkMode, setIsDarkMode] = useState(false);
  // Initialize theme based on user preference or system setting
  useEffect(() => {
    const isDark = document.documentElement.classList.contains('dark');
    setIsDarkMode(isDark);
  }, []);
  const toggleTheme = () => {
    if (isDarkMode) {
      document.documentElement.classList.remove('dark');
      localStorage.theme = 'light';
    } else {
      document.documentElement.classList.add('dark');
      localStorage.theme = 'dark';
    }
    setIsDarkMode(!isDarkMode);
  };
  return <motion.button onClick={toggleTheme} className="p-2 rounded-full bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200" whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.9
  }} aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'} data-id="element-589">
      {isDarkMode ? <Sun size={18} data-id="element-590" /> : <Moon size={18} data-id="element-591" />}
    </motion.button>;
}